import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import mask from 'jquery-mask-plugin'
import { jsPDF } from "jspdf";

import "../../css/template/elements.css"
import "../../css/blocks/mkl.css"
import qrcode from "qrcode";


export default class extends Controller {


    removeNull(receipt){
        for(let k in receipt){
            if (receipt[k] === null){
                receipt[k] = "0"
            }
            if(typeof receipt[k] === 'object'){
                this.removeNull(receipt[k])
            }
        }
    }

    pdf(){
        let self = this;
        $.ajax({
            type: "get",
            url: 'https://api.actualoptic.kz:8443/cabinet/'+ usertoken,
            contentType: "application/json",
            async: false,
            success: function(cabinet){
                $.ajax({
                    type: "get",
                    url: 'https://api.actualoptic.kz:8443/cabinet/receipt/'+ usertoken,
                    contentType: "application/json",
                    async: false,
                    success: function(data){
                        //ФОРМИРУЕМ PDF
                        //размеры в pt
                        const pageWidth    = 595;
                        const lineHeight   = 1.2;
                        const marginRight  = 5;
                        const maxLineWidth = pageWidth - (marginRight + 50);
                        const fontSize     = 10;
                        let   ptsPerInch   = 3;
                        let oneLineHeight  = (fontSize * lineHeight) + ptsPerInch;


                        const doc = new jsPDF({
                            unit: "pt",
                            lineHeight: lineHeight
                        });
                        doc.addFont("font/Montserrat.ttf", "Montserrat", "normal");
                        doc.addFont("font/Montserrat.ttf", "Montserrat", "bold");
                        doc.addFont("font/Montserrat-Bold.ttf", "MontserratBold", "normal");
                        doc.setFontSize(fontSize);
                        doc.setTextColor(0, 0, 0);

                        //ставим точки отсчета
                        let topBasePoint = 30;
                        let leftBasePoint = 30;
                        let halfPagePoint = (pageWidth - leftBasePoint ) / 2;
                        let logoWidth = 90;
                        let logoHeight = 29;
                        let topBaseClientTextPoint = (topBasePoint + logoHeight) + 15 ;
                        let receiptTableHeight = 75;


                        //ставим лого
                        doc.addImage("img/actual-optic-logo-print.jpg", "JPEG", topBasePoint, leftBasePoint, logoWidth, logoHeight);

                        //ФИО клиента
                        doc.setFont('MontserratBold');
                        doc.text('ФИО клиента:', leftBasePoint, topBaseClientTextPoint);

                        doc.setFont('Montserrat');
                        let fio = cabinet.patient.ClientName+' '+cabinet.patient.ClientSurname;
                        doc.text(fio, leftBasePoint + 100, topBaseClientTextPoint);

                        //телефон клиента
                        doc.setFont('MontserratBold');
                        doc.text('Телефон:', leftBasePoint, topBaseClientTextPoint + oneLineHeight);

                        doc.setFont('Montserrat');
                        doc.text('+'+cabinet.patient.Phone, leftBasePoint + 100, topBaseClientTextPoint + oneLineHeight);


                        //дата создания анкеты
                        doc.setFont('MontserratBold');
                        doc.text('Дата обращения:', halfPagePoint, topBaseClientTextPoint + oneLineHeight);

                        //let createdAt = new Date(cabinet.patient.CreatedAt);
                        let createdAt = new Date(data.created_at);
                        let createdAtDay = createdAt.getDate();
                        if (createdAtDay < 10){
                            createdAtDay = '0' + createdAtDay
                        }
                        let createdAtMonth = createdAt.getMonth()+1;
                        if (createdAtMonth < 10){
                            createdAtMonth = '0' + createdAtMonth
                        }
                        let createdAtDate = createdAtDay+'.'+createdAtMonth+'.'+createdAt.getFullYear();

                        doc.setFont('Montserrat');
                        doc.text(createdAtDate, halfPagePoint + 100, topBaseClientTextPoint + oneLineHeight);

                        //линия отделяем инфо пациента от рецептов
                        doc.setLineWidth(0.1);
                        doc.setDrawColor(0, 0, 0);
                        doc.line(leftBasePoint, topBaseClientTextPoint + 20, pageWidth - leftBasePoint, topBaseClientTextPoint + 20);


                        data.receipt_glass.forEach((glass, index)=>{

                               self.removeNull(glass);

                               let count = index +1
                               let reciptTitleY;
                               let visusDescrPoint = 70;
                               let visusString2 = 150;

                               if (index === 0){
                                   reciptTitleY = topBaseClientTextPoint + 35
                               } else if(index === 1) {
                                   reciptTitleY = topBaseClientTextPoint + 190
                               }  else if(index === 2) {
                                   reciptTitleY = topBaseClientTextPoint + 340
                               }

                               //заголовок рецепта
                               doc.setFont('MontserratBold');
                               let reciptTitle;
                               if (index === 0){
                                   reciptTitle = ''
                               } else {
                                   reciptTitle = '№'+ (index +1)
                               }

                               let reciptNum = 'РЕЦЕПТ НА ОЧКИ '+reciptTitle;
                               doc.text(reciptNum, leftBasePoint, reciptTitleY);

                               let visusBeforeY = reciptTitleY + oneLineHeight;
                               //visus OD ДО таблицы
                               doc.setFont('MontserratBold' );
                               doc.text('Visus OD:', leftBasePoint, visusBeforeY);

                               doc.setFont('Montserrat' );
                               doc.text(glass.OD.visus.before, leftBasePoint + visusDescrPoint, visusBeforeY);


                               //visus OS ДО таблицы
                               doc.setFont('MontserratBold' );
                               doc.text('Visus OS:', leftBasePoint + visusString2, visusBeforeY);

                               doc.setFont('Montserrat' );
                               doc.text(glass.OS.visus.before, (leftBasePoint + visusString2) + visusDescrPoint, visusBeforeY);


                               let tableY = reciptTitleY + 20;
                               let rowsWidth = (pageWidth / 7.5);
                               //таблица рецепта
                               let headers = [
                                   {
                                       id: 'empty1',
                                       name: 'empty2',
                                       prompt: ' ',
                                       width: rowsWidth,
                                       align: "center",
                                       padding: 0
                                   },
                                   {
                                       id: 'sph',
                                       name: 'sph',
                                       prompt: 'sph',
                                       width: rowsWidth,
                                       align: "center",
                                       padding: 0
                                   },
                                   {
                                       id: 'cyl',
                                       name: 'cyl',
                                       prompt: 'cyl',
                                       width: rowsWidth,
                                       align: "center",
                                       padding: 0
                                   },
                                   {
                                       id: 'ax',
                                       name: 'ax',
                                       prompt: 'ax',
                                       width: rowsWidth,
                                       align: "center",
                                       padding: 0
                                   },
                                   {
                                       id: 'Add',
                                       name: 'Add',
                                       prompt: 'Add',
                                       width: rowsWidth,
                                       align: "center",
                                       padding: 0
                                   },
                                   {
                                       id: 'pr1',
                                       name: 'pr1',
                                       prompt: 'pr1',
                                       width: rowsWidth,
                                       align: "center",
                                       padding: 0
                                   },
                                   {
                                       id: 'bas',
                                       name: 'bas',
                                       prompt: 'bas',
                                       width: rowsWidth,
                                       align: "center",
                                       padding: 0
                                   },
                                   {
                                       id: 'pr2',
                                       name: 'pr2',
                                       prompt: 'pr2',
                                       width: rowsWidth,
                                       align: "center",
                                       padding: 0
                                   },
                                   {
                                       id: 'bas',
                                       name: 'bas',
                                       prompt: 'bas',
                                       width: rowsWidth,
                                       align: "center",
                                       padding: 0
                                   }
                               ];
                               let rows = [
                                   {
                                       empty2: 'OD',
                                       sph:glass.OD.sph.toString(),
                                       cyl: glass.OD.cyl.toString(),
                                       ax: glass.OD.ax.toString(),
                                       Add: glass.OD.add.toString(),
                                       pr1: glass.OD.pr1.toString(),
                                       bas: glass.OD.bas1.toString(),
                                       pr2: glass.OD.pr2.toString(),
                                       bas2: glass.OD.bas2.toString()
                                   },
                                   {
                                       empty2: 'OS',
                                       sph:glass.OS.sph.toString(),
                                       cyl: glass.OS.cyl.toString(),
                                       ax: glass.OS.ax.toString(),
                                       Add: glass.OS.add.toString(),
                                       pr1: glass.OS.pr1.toString(),
                                       bas: glass.OS.bas1.toString(),
                                       pr2: glass.OS.pr2.toString(),
                                       bas2: glass.OS.bas2.toString()
                                   }
                               ];
                               doc.table(leftBasePoint, tableY, rows, headers, {
                                   autoSize: false,
                                   padding:1,
                                   fontSize: 10
                               });

                               let visusAfterY = reciptTitleY + receiptTableHeight;
                               //visus OD ПОСЛЕ таблицы
                               doc.setFont('MontserratBold' );
                               doc.text('Visus OD:', leftBasePoint, visusAfterY);

                               doc.setFont('Montserrat' );
                               doc.text(glass.OD.visus.after, leftBasePoint + visusDescrPoint, visusAfterY);


                               //visus OS ПОСЛЕ таблицы
                               doc.setFont('MontserratBold' );
                               doc.text('Visus OS:', leftBasePoint + visusString2, visusAfterY);

                               doc.setFont('Montserrat' );
                               doc.text(glass.OS.visus.after, (leftBasePoint + visusString2) + visusDescrPoint, visusAfterY);



                                let rcAfter = visusAfterY + oneLineHeight;
                                let rcDescrPoint = 75;
                                let rcString2 = 145;
                               //РЦ даль OD ПОСЛЕ строки с visus-ами (которые ПОСЛЕ таблицы)
                               doc.setFont('MontserratBold' );
                               doc.text('РЦ даль OD:', leftBasePoint, rcAfter);

                               doc.setFont('Montserrat' );
                               doc.text(glass.OD.rc.distance, leftBasePoint + rcDescrPoint, rcAfter);


                               //РЦ даль OD ПОСЛЕ строки с visus-ами (которые ПОСЛЕ таблицы)
                               doc.setFont('MontserratBold' );
                               doc.text('РЦ даль OS:', leftBasePoint + rcString2, rcAfter);

                               doc.setFont('Montserrat' );
                               doc.text(glass.OS.rc.distance, (leftBasePoint + rcString2) + rcDescrPoint, rcAfter);


                               //РЦ близь OD ПОСЛЕ строки с visus-ами (которые ПОСЛЕ таблицы)
                               doc.setFont('MontserratBold' );
                               doc.text('РЦ близь OD:', (rcString2 * 2) + leftBasePoint, rcAfter);

                               doc.setFont('Montserrat' );
                               doc.text(glass.OD.rc.near, (rcString2 * 2) + (leftBasePoint + rcDescrPoint), rcAfter);


                               //РЦ близь OS ПОСЛЕ строки с visus-ами (которые ПОСЛЕ таблицы)
                               doc.setFont('MontserratBold' );
                               doc.text('РЦ близь OS:', (rcString2 * 3) + leftBasePoint, rcAfter);

                               doc.setFont('Montserrat' );
                               doc.text(glass.OS.rc.near, (rcString2 * 3) + (leftBasePoint + rcDescrPoint), rcAfter);

                                if (glass.recommendedCoatedLens !== undefined && glass.recommendedCoatedLens !== "0"){
                                    let recommendedCoatedLensY = rcAfter + oneLineHeight;
                                    //Рекомендуемая оптическая линза с покрытием ПОСЛЕ строк с РЦ
                                    doc.setFont('MontserratBold' );
                                    doc.text('Рекомендуемая оптическая линза с покрытием:', leftBasePoint, recommendedCoatedLensY);

                                    doc.setFont('Montserrat' );
                                    doc.text(glass.recommendedCoatedLens, (leftBasePoint + halfPagePoint)-15, recommendedCoatedLensY);
                                }


                               let glassLensesCheckY;
                            if (glass.recommendedCoatedLens !== undefined){
                                   glassLensesCheckY = rcAfter + (oneLineHeight *2);
                            } else {
                                glassLensesCheckY = rcAfter + oneLineHeight;
                            }


                               // перечисление отмеченных значений из чекбоксов
                               let glassLensesCheck = glass.lenses;
                                if (glassLensesCheck !== undefined && glassLensesCheck !== null){

                                    let newGlassLensesCheck = [];
                                    glassLensesCheck.forEach(item => {
                                        if(item === 'distanse'){
                                            item = ' Даль'
                                        }
                                        if(item === 'reader'){
                                            item = ' Близь'
                                        }
                                        if(item === 'constance'){
                                            item = ' Постоянное ношение'
                                        }
                                        if(item === 'provision'){
                                            item = ' Курс Provision'
                                        }
                                        if(item === 'progressive'){
                                            item = ' Прогрессивные'
                                        }
                                        if(item === 'single'){
                                            item = ' Однофокальные'
                                        }
                                        if(item === 'bifocal'){
                                            item = ' Бифокальные'
                                        }
                                        if(item === 'office'){
                                            item = ' Офисные'
                                        }
                                        newGlassLensesCheck.push(item);
                                    });
                                    let glassLensesCheckText = newGlassLensesCheck.toString();
                                    doc.text(glassLensesCheckText, leftBasePoint - 3, glassLensesCheckY);
                                }


                           });

                        //в зависимости от количества рецептов считаем Y для строк
                        // базируемся от заголовка рецепта
                        let receiptQuantity = data.receipt_glass.length;
                        let receiptTitleY;
                        if (receiptQuantity === 1){
                            receiptTitleY = topBaseClientTextPoint + 130
                        } else if(receiptQuantity === 2) {
                            receiptTitleY = topBaseClientTextPoint + 290
                        }  else if(receiptQuantity === 3) {
                            receiptTitleY = topBaseClientTextPoint + 430
                        }
                        // Примечания
                        let noteY = receiptTitleY + 52;
                        doc.setFont('MontserratBold');
                        doc.text('Примечания:', leftBasePoint, noteY);

                        doc.setFont('Montserrat');
                        doc.text(data.receipt_glass[0].notes, leftBasePoint + 100, noteY);


                        // рекомендации
                        let recommendationsY = receiptTitleY + 64;
                        doc.setFont('MontserratBold');
                        doc.text('Рекомендации:', leftBasePoint, recommendationsY);

                        doc.setFont('Montserrat');
                        doc.text(data.receipt_glass[0].recommendations, leftBasePoint + 100, recommendationsY);

                        // перечисление отмеченных значений тип линз
                        let glassLensesTypeCheckY = receiptTitleY + 76;
                        doc.setFont('MontserratBold');
                        doc.text('Тип линз:', leftBasePoint, glassLensesTypeCheckY);

                        doc.setFont('Montserrat');
                        console.debug(data.receipt_glass[0].lensesType);
                        let glassLensesTypeCheck = data.receipt_glass[0].lensesType;
                        if (glassLensesTypeCheck !== undefined && glassLensesTypeCheck !== '0'){
                            let newGlassLensesTypeCheck = [];
                            glassLensesTypeCheck.forEach(item => {
                                if(item === 'relax'){
                                    item = ' Relax'
                                }
                                if(item === 'pf'){
                                    item = ' PF'
                                }
                                if(item === 'rxindi'){
                                    item = ' RX INDI'
                                }
                                if(item === 'rxfftf'){
                                    item = ' RX FF/TF'
                                }

                                newGlassLensesTypeCheck.push(item);
                            });
                            let glassLensesTypeCheckText = newGlassLensesTypeCheck.toString();
                            doc.text(glassLensesTypeCheckText, leftBasePoint +97, glassLensesTypeCheckY);
                        }


                        //линия - отделяем рецепты очков от рецепта линз/от диагноза
                        let bottomLineY = receiptTitleY + 84;
                        doc.setLineWidth(0.1);
                        doc.setDrawColor(0, 0, 0);
                        doc.line(leftBasePoint, bottomLineY, pageWidth - leftBasePoint, bottomLineY);


                        /* если есть МКЛ - строим рецепт */

                        if (data.receipt_lens !== null){
                            if (data.receipt_lens.OD !== undefined  &&  data.receipt_lens.OS !== undefined)  {

                                self.removeNull(data.receipt_lens);


                                //заголовок для МКЛ
                                let reciptMklTitleY = receiptTitleY + 104;
                                doc.setFont('MontserratBold');
                                doc.text('РЕЦЕПТ НА МКЛ', leftBasePoint, reciptMklTitleY);


                                //таблица для МКЛ
                                doc.setFont('Montserrat');
                                let tableMklY = reciptMklTitleY + 5;
                                let rowsMklWidth = (pageWidth / 7.5);
                                let mklHeaders = [
                                    {
                                        id: 'empty1',
                                        name: 'empty2',
                                        prompt: ' ',
                                        width: rowsMklWidth,
                                        align: "center",
                                        padding: 0
                                    },
                                    {
                                        id: 'sph',
                                        name: 'sph',
                                        prompt: 'sph',
                                        width: rowsMklWidth,
                                        align: "center",
                                        padding: 0
                                    },
                                    {
                                        id: 'cyl',
                                        name: 'cyl',
                                        prompt: 'cyl',
                                        width: rowsMklWidth,
                                        align: "center",
                                        padding: 0
                                    },
                                    {
                                        id: 'ax',
                                        name: 'ax',
                                        prompt: 'ax',
                                        width: rowsMklWidth,
                                        align: "center",
                                        padding: 0
                                    },
                                    {
                                        id: 'add',
                                        name: 'add',
                                        prompt: 'Add',
                                        width: rowsMklWidth,
                                        align: "center",
                                        padding: 0
                                    },
                                    {
                                        id: 'bc',
                                        name: 'bc',
                                        prompt: 'bc',
                                        width: rowsMklWidth,
                                        align: "center",
                                        padding: 0
                                    },
                                    {
                                        id: 'dia',
                                        name: 'dia',
                                        prompt: 'Dia',
                                        width: rowsMklWidth,
                                        align: "center",
                                        padding: 0
                                    },
                                ];
                                let mklRows = [
                                    {
                                        empty2: 'OD',
                                        sph: data.receipt_lens.OD.sph,
                                        cyl: data.receipt_lens.OD.cyl,
                                        ax:  data.receipt_lens.OD.ax,
                                        add:  data.receipt_lens.OD.add,
                                        bc:  data.receipt_lens.OD.bc,
                                        dia:  data.receipt_lens.OD.dia,
                                    },
                                    {
                                        empty2: 'OS',
                                        sph: data.receipt_lens.OS.sph,
                                        cyl: data.receipt_lens.OS.cyl,
                                        ax:  data.receipt_lens.OS.ax,
                                        add:  data.receipt_lens.OS.add,
                                        bc:  data.receipt_lens.OS.bc,
                                        dia:  data.receipt_lens.OS.dia,
                                    },
                                ];
                                doc.table(leftBasePoint, tableMklY, mklRows, mklHeaders, {
                                    autoSize: false,
                                    padding:1,
                                    fontSize: 10
                                });


                                // перечисление отмеченных значений из чекбоксов для МКЛ
                                let typeListY = tableMklY + 55;
                                let typeList = data.receipt_lens.type;
                                if (typeList !== '0'){
                                    let newTypeList = [];
                                    typeList.forEach(item => {
                                        if(item === 'hy'){
                                            item = ' Hy'
                                        }
                                        if(item === 'siHy'){
                                            item = ' Si-Hy'
                                        }
                                        if(item === 'torica'){
                                            item = ' Torica'
                                        }
                                        if(item === 'other'){
                                            item = ' Другие ('+ data.receipt_lens.typeOther+')'
                                        }
                                        newTypeList.push(item);
                                    });
                                    let typeListText = newTypeList.toString();
                                    doc.text(typeListText, leftBasePoint - 3, typeListY);
                                }


                                // МКЛ наименование
                                let mklNameY = typeListY + oneLineHeight;
                                doc.setFont('MontserratBold');
                                doc.text('Наименование:', leftBasePoint, mklNameY);

                                doc.setFont('Montserrat');
                                doc.text(data.receipt_lens.name, leftBasePoint + 100, mklNameY);


                                // МКЛ Режим замены
                                let mklModeY = mklNameY + oneLineHeight;
                                doc.setFont('MontserratBold');
                                doc.text('Режим замены:', leftBasePoint, mklModeY);

                                doc.setFont('Montserrat');
                                doc.text(data.receipt_lens.mode, leftBasePoint + 100, mklModeY);

                                // МКЛ Режим ношения
                                let mklWearingY = mklModeY + oneLineHeight;
                                doc.setFont('MontserratBold');
                                doc.text('Режим ношения:', leftBasePoint, mklWearingY);

                                doc.setFont('Montserrat');
                                doc.text(data.receipt_lens.wearing, leftBasePoint + 100, mklWearingY);

                                //линия - отделяем рецепты очков от рецепта линз
                                let mklLineY = mklWearingY + 10;
                                doc.setLineWidth(0.1);
                                doc.setDrawColor(0, 0, 0);
                                doc.line(leftBasePoint, mklLineY, pageWidth - leftBasePoint, mklLineY);
                            }
                        }


                        //таблица для диагноза
                        if (data.receipt_glass[0].diagnosis !== undefined && data.receipt_glass[0].diagnosis !== null && data.receipt_glass[0].diagnosis !== "0"){
                            let tableMklY;
                            if (
                                data.receipt_lens === null ||
                                data.receipt_lens.OD === undefined  ||
                                data.receipt_lens.OS === undefined
                            ){
                                tableMklY = receiptTitleY + 85;
                            } else {
                                tableMklY = receiptTitleY + 215;
                            }
                            doc.setFont('Montserrat');
                            let rowsMklWidth = (pageWidth / 7.5) * 9;
                            let mklHeaders = [
                                {
                                    id: 'diagnosis',
                                    name: 'diagnosis',
                                    prompt: 'Диагноз',
                                    width: rowsMklWidth,
                                    align: "left",
                                    padding: 10
                                }
                            ];
                            let mklRows = [
                                {
                                    diagnosis: data.receipt_glass[0].diagnosis,
                                }
                            ];
                            doc.table(leftBasePoint, tableMklY, mklRows, mklHeaders, {
                                autoSize: false,
                                padding:1,
                                fontSize: 10
                            });

                        }


                        //доктор
                        let doctorY = 815;
                        doc.setFont('MontserratBold');
                        doc.text('Доктор:', leftBasePoint, doctorY);

                        doc.setFont('Montserrat');
                        doc.text(data.doctor_name, leftBasePoint + 50, doctorY);


                        //генерим название файла для юзера
                        let fileFio = cabinet.patient.ClientName+'-'+cabinet.patient.ClientSurname;
                        let fileCreatedAtDate = createdAtDay+'.'+createdAtMonth+'.'+createdAt.getFullYear();
                        doc.save(fileFio +"-рецепт-на-очки-от-"+fileCreatedAtDate+".pdf");
                    },
                });

            },
            error(error){
                console.debug(error);
                //window.location.replace("404.html");
            }
        });




    }


    connect() {
        $.ajax({
            type: "get",
            url: 'https://api.actualoptic.kz:8443/cabinet/receipt/'+ usertoken,
            contentType: "application/json",
            async: false,
            success: function(data){
                console.debug(data);
                if (data !== null){
                    $('#receiptBox').html('<button class="btn pdfLoad" data-action="click->receipt#pdf">Скачать рецепт от&nbsp;<span id="receipt__date"></span></button>');
                    let receiptDate = new Date(data.created_at);
                    let receiptDateDay = receiptDate.getDate();
                    if (receiptDateDay < 10){
                        receiptDateDay = '0' + receiptDateDay
                    }
                    let receiptDateMonth = receiptDate.getMonth() +1;
                    if (receiptDateMonth < 10){
                        receiptDateMonth = '0' + receiptDateMonth
                    }
                    $('#receipt__date').text(receiptDateDay + '.' + receiptDateMonth + '.' + receiptDate.getFullYear())
                } else {
                    $('#receiptBox').html('' +
                        '<p>У Вас еще нет рецептов.</p>' +
                        '<a href="https://actualoptic.kz/staffs/?type=doctor" target="_blank"><strong>Пройти диагностику в Actual Optic</strong></a>' +
                        '')
                }



            },
            error(error){
                console.debug(error);
                //window.location.replace("404.html");
            }
        });

    }
}
